import { SERVER_BASE_URL } from '../config';

interface SongInfo {
  title: string;
  song: string;
  artist: string;
}

export interface VideoSearchResult {
  id: string;
  title: string;
  thumbnailUrl: string;
  viewCount: string;
}

async function postJson<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${SERVER_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let msg = res.statusText;
    try {
      const data = await res.json();
      if (data?.error) msg = data.error;
    } catch {}
    throw new Error(msg);
  }
  return res.json() as Promise<T>;
}

export const extractSongInfo = async (videoTitle: string): Promise<{ song: string; artist: string }> => {
  try {
    const { song, artist } = await postJson<{ song: string; artist: string }>('/api/parse-song-info', { title: videoTitle });
    return {
      song: song || 'Unknown',
      artist: artist || 'Unknown',
    };
  } catch (error) {
    console.error('Error extracting song info:', error);
    return { song: 'Unknown', artist: 'Unknown' };
  }
};

export const youtubeService = {
  async getSongInfo(youtubeUrl: string): Promise<SongInfo> {
    const videoId = youtubeUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/)?.[1];
    if (!videoId) throw new Error('Invalid YouTube URL');

    const info = await postJson<{ title: string }>('/api/youtube/video-info', { videoId });
    const title = info.title || '';
    if (!title) throw new Error('Video not found');

    const parsed = await postJson<{ song: string; artist: string }>('/api/parse-song-info', { title });
    return {
      title,
      song: parsed.song,
      artist: parsed.artist,
    };
  },

  async searchVideos(query: string): Promise<VideoSearchResult[]> {
    return postJson<VideoSearchResult[]>('/api/youtube/search', { query });
  },
};
